var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessengerUnavailableImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "94px",
    height: "80px",
    viewBox: "0 0 94 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Conversation-Media",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-empty-state",
    transform: "translate(-140.000000, -386.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(13.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.812394,71.2571048 L178.731218,2.78852207 C177.692987,1.05810187 175.828853,0 173.818047,0 C171.80724,0 169.943106,1.05791807 168.904875,2.78852207 L127.824065,71.2571048 C126.755658,73.0378845 126.724019,75.2590346 127.741584,77.069589 C128.75915,78.8803272 130.667907,80 132.737054,80 L214.899222,80 C216.968369,80 218.877126,78.8801434 219.894691,77.069589 C220.912257,75.2588508 220.880801,73.0378845 219.812394,71.2571048 Z M174.303907,23.6363636 C176.749163,23.6363636 178.818182,24.9594496 178.818182,27.304573 C178.818182,34.4604719 177.940422,44.7437474 177.940422,51.8996463 C177.940422,53.7639285 175.808665,54.5454545 174.303907,54.5454545 C172.297815,54.5454545 170.604843,53.7637467 170.604843,51.8996463 C170.604843,44.7437474 169.727273,34.4604719 169.727273,27.304573 C169.727273,24.9594496 171.733365,23.6363636 174.303907,23.6363636 Z M173.393364,68.1818182 C170.779128,68.1818182 168.818182,66.0566799 168.818182,63.6363636 C168.818182,61.1569761 170.778949,59.0909091 173.393364,59.0909091 C175.829414,59.0909091 177.909091,61.1569761 177.909091,63.6363636 C177.909091,66.0566799 175.829414,68.1818182 173.393364,68.1818182 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerUnavailableImage);
export default __webpack_public_path__ + "static/media/MessengerUnavailableImage.24d6efbca235aba23917c770813824c1.svg";
export { ForwardRef as ReactComponent };